module.exports = __webpack_public_path__ + "img/auth-galeria-pomorska-logo-bg.f53083d0.png";